import Vue from 'vue/dist/vue.esm'
import VueRouter from 'vue-router';
Vue.use(VueRouter)

import page_404 from '@partials/page_404.vue'

import admin from '@layouts/admin/layout.vue'
import provider from '@layouts/provider/layout.vue'
import customer from '@layouts/customer/layout.vue'

import admin_router from '@layouts/admin/routes.js'
import provider_router from '@layouts/provider/routes.js'
import customer_router from '@layouts/customer/routes.js'

const router = new VueRouter({
    mode: process.env.VUE_APP_BUILD_ENV == 'electron' ? 'hash':'history',
    routes: [
        {
            path: '/admin', component: admin,
            children: admin_router
        },
        {
            path: '/provider', component: provider,
            children: provider_router
        },
        {
            path: '/customer', component: customer,
            children: customer_router
        },
        {
            path: '*', component: page_404, name: 'page_404',
        }
    ]
})

export default router;
